const APP_DEFAULTS = {
    perPage: 12,
    ordersPerPage: 5,
    zoneId: 6,
    zoneLabel: 'Cuba - La Habana',
    showCartExpiringMessageAt: [10, 5, 3],
    extraMinutesOnCheckout: 7,
    desktopBreakpoint: 768,
    countryIsoCuba: 'CU',
    countryIsoUS: 'US',
    info_email: 'info@cubalicores.com',
    // IT NEEDS TO BE UPDATED
    toBeDonatedInfo: {
        zoneId: 0,
        address1: 'fake-line-1',
        address2: 'fake-line-2',
        city: 'San Miguel del Padrón',
        country_iso: 'CU',
        firstname: 'Dummy',
        lastname: 'Dummy',
        phone: '555555',
        state_name: 'DON',
        zipcode: '11000',
    },
    theme: {
        submenuTitleColor: 'black', // overrides blue
        desktopItemOpenColor: '#b18433', // overrides #d3af71
        mobileMenuTitleBottomColor: '#b18433', // overrides red
        mobileMenuItemColor: 'black', // overrides #d3af71
        mobileMenuSubitemColor: 'black', // overrides #d3af71
        localeSelectorColor: '#b18433', // overrides #d3af71
        mainManeDividerColor: 'black', // overrides silver
        mainMenuDropdownColor: '#dcccae', // overrides #d3af71
        cartBadgeBackgroundColor: '#b18433', // overrides #d3af71
        cartFillColor: '#b18433', // overrides #FE6902
        clearFilterColor: 'black', // overrides #18396C
    },
    modalTimeout: 20000,
};

export default APP_DEFAULTS;



/** WEBPACK FOOTER **
 ** ./src/constants/app-defaults.js
 **/